import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { CategoryData } from "../setup/setupResponse";
// import { Category } from "../../types/category";

export type ModalType =
    | null
    | 'newStaff'
    | 'updateStaff'
    | 'newChapel'
    | 'updateChapel'
    | 'newProduct'
    | 'updateProduct'
    | 'newCategory'
    | 'updateCategory'
    | 'newPackage'
    | 'updatePackage'
    | 'viewCategoryAndProduct'
    | 'viewPackage'
    | 'selectedItem'
    | 'addQtyProduct'
    | 'cancelledOrder'
    | 'isLogOut'
    | 'isNewGuest'
    | 'clientReport'

type AdditionalModalType = 
    null
    | 'addQtyItem'
    | 'addPackage'
    | 'viewClientPackageSummary'
    | 'getNewPIN'
    | 'viewPackageItem'
    | 'viewClientPackages'
    | 'updateClient'
    | 'viewDefaultPackage'
    | 'viewPackageToAdd'
    | 'viewPackageItemCash'
    | 'showDeleteModal'
    | 'showSpecialPackageAddItem'
    | 'showExportBillingTypes'

type ThirdModalType = 
    null
    | 'viewPackageSelected'
    | 'viewUpdateSpecialPackageProduct'
    | 'viewSelectedSpecialProduct'

type ShowModalType = 
    null 
    | 'chapelModal'
    | 'staffModal'
    | 'fbTypeModal'
    | 'packageModal'
    | 'productModal'
    | 'categoryModal'
    | 'viewCategoryAndProductModal'
    | 'viewListOfProduct'
    | 'viewPackageModal'
    | 'newPackageModal'
    | 'updatePackageModal'
    | 'newClient' 
    | 'viewClient'
    | 'viewCart'
    | 'viewOrder'
    | 'viewOrderDetails'
    | 'updateOrder'
    | 'viewClientDetails'
    | 'viewUserDetails'
    | 'viewAndUpdateUserDetails'
    | 'viewProfileDetails'
    | 'isUpdateStatusOfPackage'

interface ModalState {
    typeModal: ModalType;
    typeOfCategory: CategoryData | null
    typeAdditionalModal: AdditionalModalType | null
    typeShowModalType: ShowModalType | null
    selectedId: number | null;
    typeThirdModalType: ThirdModalType | null
    isFetching: boolean
}

const initialState: ModalState = {
    typeModal: null,
    typeOfCategory: null,
    typeAdditionalModal: null,
    typeShowModalType: null,
    selectedId: null,
    typeThirdModalType: null,
    isFetching: false
};

const modalSlice = createSlice({
    name: 'modal',
    initialState,
    reducers: {
        setTypeModal: (state, action: PayloadAction<ModalType>) => {
            state.typeModal = action.payload;
        }, 
        clearTypeModal: (state) => {
            state.typeModal = null;
        },
        setTypeOfCategory: (state, action: PayloadAction<CategoryData>) => {
            state.typeOfCategory = action.payload;
        },
        clearTypeOfCategory: (state) => {
            state.typeOfCategory = null;
        },
        setTypeOfAdditionalModal: (state, action:  PayloadAction<AdditionalModalType>) => {
            state.typeAdditionalModal = action.payload;
        },
        clearTypeOfAdditionalModal: (state) => {
            state.typeAdditionalModal = null;
        },
        setShowDeleteModal: (state, action:  PayloadAction<AdditionalModalType>) => {
            state.typeAdditionalModal = action.payload;
        },
        clearShowDeleteModal: (state) => {
            state.typeAdditionalModal = null;
        },
        setTypeOfShowModalType: (state, action:  PayloadAction<ShowModalType>) => {
            state.typeShowModalType = action.payload;
        },
        clearTypeOfShowModalType: (state) => {
            state.typeShowModalType = null;
        },
        setSelectedId: (state, action: PayloadAction<number>) => {
            state.selectedId = action.payload;
        },
        clearSelectedId: (state) => {
            state.selectedId = null;
        },

        setTypeOfThirdModal: (state, action:  PayloadAction<ThirdModalType>) => {
            state.typeThirdModalType = action.payload;
        },
        clearTypeOfThirdModal: (state) => {
            state.typeThirdModalType = null;
        },
        setIsFetching: (state, action: PayloadAction<boolean>) => {
            state.isFetching = action.payload;
        },
    },
});

export const { 
    setTypeModal, 
    clearTypeModal, 
    setTypeOfCategory, 
    clearTypeOfCategory,
    setTypeOfAdditionalModal,
    clearTypeOfAdditionalModal,
    setTypeOfShowModalType,
    clearTypeOfShowModalType,
    setSelectedId, 
    clearSelectedId,
    setTypeOfThirdModal,
    clearTypeOfThirdModal,
    setIsFetching,
    setShowDeleteModal,
    clearShowDeleteModal
} = modalSlice.actions;
export default modalSlice.reducer;

export const selectCurrentModalType = (state: RootState) => state.modal.typeModal;
export const selectCategoryType = (state: RootState) => state.modal.typeOfCategory;
export const selectCategoryName = (state: RootState) => state.modal.typeOfCategory?.categoryName;
export const selectCategoryTypeId = (state: RootState) => state.modal.typeOfCategory?.categoryID;
export const selectCurrentAdditionalModalType = (state: RootState) => state.modal.typeAdditionalModal;
export const selectCurrentShowTypeOfModal = (state: RootState) => state.modal.typeShowModalType;
export const selectSelectedId = (state: RootState) => state.modal.selectedId;
export const selectCurrentThirdModalType = (state: RootState) => state.modal.typeThirdModalType;
export const selectIsFetching = (state: RootState) => state.modal.isFetching;